/**
 * @generated SignedSource<<1f29520972009ac28abc5bf5763d190a>>
 * @relayHash f45120635d963ea93639bee3861a36d1
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 566cbf67893a44ef543945f70eee4bcd578e1c8b28c85f49c0ffecf8bf42a37c

import type { ConcreteRequest } from 'relay-runtime';
export type preloadContentSmartLinksQuery$variables = {
  contentId: string;
};
export type preloadContentSmartLinksQuery$data = {
  readonly contentSmartLinks: {
    readonly nodes: ReadonlyArray<{
      readonly __typename: string;
      readonly title: string | null | undefined;
      readonly url: string;
    } | null | undefined> | null | undefined;
  } | null | undefined;
};
export type preloadContentSmartLinksQuery = {
  response: preloadContentSmartLinksQuery$data;
  variables: preloadContentSmartLinksQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "contentId"
  }
],
v1 = [
  {
    "args": [
      {
        "kind": "Variable",
        "name": "id",
        "variableName": "contentId"
      }
    ],
    "concreteType": "PaginatedSmartLinkList",
    "kind": "LinkedField",
    "name": "contentSmartLinks",
    "plural": false,
    "selections": [
      {
        "kind": "LinkedField",
        "name": "nodes",
        "plural": true,
        "selections": [
          {
            "kind": "ScalarField",
            "name": "__typename"
          },
          {
            "kind": "ScalarField",
            "name": "url"
          },
          {
            "kind": "ScalarField",
            "name": "title"
          }
        ]
      }
    ]
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "name": "preloadContentSmartLinksQuery",
    "selections": (v1/*: any*/),
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "preloadContentSmartLinksQuery",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "f45120635d963ea93639bee3861a36d1",
    "id": "566cbf67893a44ef543945f70eee4bcd578e1c8b28c85f49c0ffecf8bf42a37c",
    "metadata": {},
    "name": "preloadContentSmartLinksQuery",
    "operationKind": "query",
    "text": "query preloadContentSmartLinksQuery($contentId:ID!){contentSmartLinks(id:$contentId){nodes{__typename,url,title}}}"
  }
};
})();

(node as any).hash = "4076c519fe140172959b6873ee116c5c";

export default node;
